import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDataSource } from "../../contexts/dataSource";
import { getPropsDataGrid } from "../../utils/default-props";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "devextreme-react";
import { Column, Editing, Toolbar, MasterDetail, Item } from "devextreme-react/cjs/data-grid";
import { usePublicEvents } from "../../contexts/public-events";
import { useAuth } from "../../contexts/auth";
import LoaderPage from "../../layouts/loader-page/loader-page";

function TravelRequestList() {
    const [id, setId] = useState<string>();
    const [loading, setLoading] = useState(false);
    const { dataSourceHR } = useDataSource();
    const navigate = useNavigate();
    const { setPublicAddEvent } = usePublicEvents();
    const { user } = useAuth();

    const dataSource = useMemo(() =>
        dataSourceHR({
            loadUrl: "/api/EmployeeTravel",
            insertUrl: "/api/EmployeeTravel/FormData",
            onBeforeSend: (e) => {
                if (e.method === "GET") {
                    setLoading(true);
                }
            },
            onLoaded: () => {
                setLoading(false);
            }
        }),
        [dataSourceHR]);

    const handleFocusedRowChange = (e: any) => {
        setId(e.component.option('focusedRowKey'));
    };

    const handleRowDblClick = (e: any) => {
        if (e.data?.id) {
            navigate(`/travel-request/${e.data.id}`);
        }
    };

    useEffect(() => {
        if (setPublicAddEvent) {
            setPublicAddEvent(() => {
                return () => navigate('/my-travel/travel-request');
            });
        }
        return () => {
            if (setPublicAddEvent) {
                setPublicAddEvent(undefined);
            }
        };
    }, [setPublicAddEvent, navigate]);

    const renderEmployeeDetail = (props: any) => {
        return (
            <div className="px-4 py-2">
                <DataGrid
                    dataSource={props.data.employeeBusinessTripEmployees}
                    showBorders={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    rowAlternationEnabled={true}
                    hoverStateEnabled={true}
                >
                    <Column
                        dataField="employeeName"
                        caption="Çalışan"
                        width={200}
                    />
                    <Column
                        dataField="description"
                        caption="Açıklama"
                        width={200}
                    />
                    <Column
                        dataField="startDate"
                        caption="Başlangıç Tarihi"
                        dataType="date"
                        format="dd.MM.yyyy"
                        width={120}
                    />
                    <Column
                        dataField="endDate"
                        caption="Bitiş Tarihi"
                        dataType="date"
                        format="dd.MM.yyyy"
                        width={120}
                    />
                    <Column
                        dataField="fromBusinessTripLocationName"
                        caption="Nereden"
                        width={120}
                    />
                    <Column
                        dataField="toBusinessTripLocationName"
                        caption="Nereye"
                        width={120}
                    />
                    <Column
                        dataField="businessTripTransportationName"
                        caption="Ulaşım"
                        width={120}
                    />
                    <Column
                        dataField="businessTripAccommodationName"
                        caption="Konaklama"
                        width={120}
                    />
                    <Column
                        dataField="willBeBusinessTripInsurance"
                        caption="Seyahat Sigortası"
                        dataType="boolean"
                        width={120}
                    />
                    <Column
                        dataField="isVaccinationRequirement"
                        caption="Aşı Gerekli"
                        dataType="boolean"
                        width={100}
                    />
                    <Column
                        dataField="isPassportRequired"
                        caption="Pasaport Gerekli"
                        dataType="boolean"
                        width={120}
                    />
                </DataGrid>
            </div>
        );
    };

    return (
        <LoaderPage loading={loading}>
            <div className="content-block">
                <div className="dx-card responsive-paddings">
                    <DataGrid
                        {...getPropsDataGrid}
                        dataSource={dataSource}
                        focusedRowKey={id}
                        onFocusedRowChanged={handleFocusedRowChange}
                        onRowDblClick={handleRowDblClick}
                        showBorders={true}
                        columnAutoWidth={true}
                        rowAlternationEnabled={true}
                        hoverStateEnabled={true}
                        keyExpr="id"
                    >
                        <Toolbar>
                            <Item location="before">
                                <div className="grid-header">Seyahat Talepleri</div>
                            </Item>
                        </Toolbar>

                        <Column
                            dataField="businessTripPurposeName"
                            caption="Seyahat Amacı"
                            width={200}
                        />
                        <Column
                            dataField="description"
                            caption="Açıklama"
                            width={300}
                        />
                        <Column
                            dataField="workAdvance"
                            caption="İş Avansı"
                            dataType="number"
                            format="#,##0.00 ₺"
                            width={150}
                            alignment="right"
                        />

                        <MasterDetail
                            enabled={true}
                            component={renderEmployeeDetail}
                        />

                        <Editing
                            allowDeleting={user?.permissions?.includes('DELETE_TRAVEL_REQUEST')}
                            allowUpdating={false}
                            useIcons={true}
                        />
                    </DataGrid>
                </div>
            </div>
        </LoaderPage>
    );
}

export default TravelRequestList;